module.exports = __webpack_public_path__ + "static/media/FlowDesignSVG.373270fa.png";